import { render, staticRenderFns } from "./SelectLang.vue?vue&type=template&id=eef0ebee&scoped=true&"
import script from "./SelectLang.vue?vue&type=script&lang=js&"
export * from "./SelectLang.vue?vue&type=script&lang=js&"
import style0 from "./SelectLang.vue?vue&type=style&index=0&id=eef0ebee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef0ebee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eef0ebee')) {
      api.createRecord('eef0ebee', component.options)
    } else {
      api.reload('eef0ebee', component.options)
    }
    module.hot.accept("./SelectLang.vue?vue&type=template&id=eef0ebee&scoped=true&", function () {
      api.rerender('eef0ebee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/SelectLang.vue"
export default component.exports